<template>
    <div>
        <div class="border-bottom mb-3" v-for="(filter, index) in sortedFilters" :key="index">
            <div class="accordion" :id="`accordion_${index}`">
                <div class="accordion-item">
                    <h2 class="accordion-header" :id="`heading_${index}`">
                    <button class="accordion-button px-0 pt-0" type="button" data-bs-toggle="collapse" :data-bs-target="`#collapse_${index}`" aria-expanded="false" :aria-controls="`collapse_${index}`">
                        <label class="filter-title">{{getFilterKey(filter).replace('ategoria', 'ategoría')}}</label>
                    </button>
                    </h2>
                    <div :id="`collapse_${index}`" class="accordion-collapse collapse show" :aria-labelledby="`heading_${index}`" :data-bs-parent="`#accordion_${index}`">
                        <div class="accordion-body px-0">
                            <div class="mb-3">
                                <p class="clear-filters-text filter-option mb-3 overflow-hidden" @click="clearFilter(Object.keys(filter)[0])">
                                  {{ filtersMultiLanguageText }}
                                </p>

                              <div class="filter-option checkbox-container overflow-hidden" v-for="(option, key) in sortedTaxonomies(filter)" :key="key">
                                    <input :id="`option_${key}_${index}`" type="checkbox" class="filter-input" :value="option.slug" v-model="urlFilters[getFilterKey(filter)]"/>
                                    <label class="mx-1" :for="`option_${key}_${index}`">{{option.title}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>

        <template v-if="configTexts && configTexts.mapText">
            <a class="btn btn-primary d-none d-md-flex flex-nowrap align-items-center justify-content-center" :href="terminalsUrl">
                <span class="pe-3" v-html="configTexts.mapText"></span> <img src="https://asurcloudrunprod-16905.kxcdn.com/public-assets/right-arrow-icon" alt="arrow" class="arrow-icon">
            </a>
        </template>

        <div class="d-none d-md-block">
            <div class="my-3" v-if="configTexts && configTexts.banner">
                <div class="banner text-center d-flex flex-row flex-md-column py-2 px-3 px-sm-5 px-md-2 justify-content-center align-items-center">
                    <img v-if="configTexts.banner.image && configTexts.banner.image.value" :src="configTexts.banner.image.value.public_path" class="catalog-img"/>
                    <span class="filter-banner-span" v-if="configTexts.banner.text && configTexts.banner.text.value" v-html="configTexts.banner.text.value"/>
                </div>
                <a class="btn btn-secondary d-flex flex-nowrap align-items-center justify-content-center"
                    :href="downloadsUrl"
                    v-if="configTexts.banner.cta && configTexts.banner.cta.value">

                    <span class="pe-3">{{configTexts.banner.cta.value.title}}</span>
                    <img src="https://asurcloudrunprod-16905.kxcdn.com/public-assets/right-arrow-icon" alt="arrow" class="arrow-icon">
                </a>
            </div>
        </div>
        
    </div>
</template>
<script>
import FilterManager from './filter-manager.js';
export default {
    props: { 
        filters: {
            type: Array,
            required: true
        },
        locale: String,
        configTexts: Object,
        customOrder: Boolean
    },
    mixins: [FilterManager],
    computed: {
        sortedFilters() {
            return Boolean(this.filters?.length) ? this.filters.sort((a, b) => (Object.keys(a)[0] < Object.keys(b)[0] ? 1 : -1)) : []
        },
        terminalsUrl() {
            return this.locale == 'es' ? '/es/terminales' : '/en/terminals';
        },
        downloadsUrl() {
            return this.locale == 'es' ? '/es/catalogo/descargar' : '/en/catalog/download';
        },
        filtersMultiLanguageText() {
            return this.locale == 'es' ? 'Limpiar filtros' : 'Clear filters'
        }
    },
    methods: {
        getFilterKey(data) {
            return Object.keys(data)[0]
        },
        sortedTaxonomies(filter) {
            const key = this.getFilterKey(filter);
            if (key === 'terminal') {
              return filter[key].sort((a, b) => a.title > b.title ? 1 : (b.title > a.title ? -1 : 0))
            } else {
              return filter[key].sort((a, b) => (parseInt(a.order) > parseInt(b.order)) ? 1 : ((parseInt(b.order) > parseInt(a.order) ? -1 : 0)))
            }
        },
        clearFilter(type) {
          this.urlFilters[type]= []
        }
    }
}
</script>
<style lang="scss" scoped>
.catalog-img {
    width: calc(9vw + 9vh);
    height: calc(12vw + 12vh);
    object-fit: contain;
}
.filter-banner-span{
    font-size: 1.4em;
}
@media screen and (min-width:768px){
    .catalog-img {
    width: calc(9vw + 9vh);
    height: auto;
    object-fit: contain;
}
.filter-banner-span{
    font-size: 1em;
}
}

.checkbox-container label::before {
  min-width: 1em;
}

.clear-filters-text{
  text-decoration: underline;
  color: red;
  font-weight: bold;
  cursor: pointer;
}
</style>